import { ProductLinePermission } from 'src/app/core/interfaces/permissions';
import {
  BrandSettingsGeneralPage,
  BrandSettingsNotificationsPage,
} from './pages';
import { BrandSettings } from './brand-settings.setup';

export const BrandSettingsModule: ProductLinePermission = {
  id: BrandSettings.id,
  title: 'PAGE.BRAND_SETTINGS.TITLE',
  path: BrandSettings.path,
  pages: [
    BrandSettingsGeneralPage,
    BrandSettingsNotificationsPage,
  ],
  showInSidebar: true,
  iconClass: 'fal fa-wrench',
};
